__turbopack_context__.v({
  "root": "index-module__W9PmRG__root",
});
